import {Editor, EditorOptions} from 'tinymce';
import {MergeTagsItem} from '../types';

const option: {
  <K extends keyof EditorOptions>(name: K): (editor: Editor) => EditorOptions[K];
  <T>(name: string): (editor: Editor) => T;
} = (name: string) => (editor: Editor) =>
  editor.options.get(name);

const register = (editor: Editor): void => {
  const registerOption = editor.options.register;

  registerOption('merge_tags_prefix', {
    'processor': 'string',
    default: '{{'
  });
  registerOption('merge_tags_suffix', {
    'processor': 'string',
    default: '}}'
  });
  registerOption('merge_tags_list', {
    'processor': 'object[]',
    default: []
  });
  registerOption('merge_tags_editable', {
    'processor': 'boolean',
    default: false,
  });
};

const getMergeTagsPrefix = option<string>('merge_tags_prefix');
const getMergeTagsSuffix = option<string>('merge_tags_suffix');
const getMergeTagsList = option<MergeTagsItem[]>('merge_tags_list');
const getMergeTagsEditable = option<boolean>('merge_tags_editable');

export {
  register,
  getMergeTagsPrefix,
  getMergeTagsSuffix,
  getMergeTagsList,
  getMergeTagsEditable,
};
